export const DUPLICATE_PAYMENT_HOURS = 48
export const DUPLICATE_PAYMENT_FREEZE_MINUTES = 2
